import { VisualizationType, EditableComponent } from '../../models';
import { VisualizationTypeStrategy } from '../models';
import { StatusCardGroupPropertiesPanel } from './StatusCardGroupPropertiesPanel';
import StatusCardGroupEditor from './StatusCardGroup.json';

export class StatusCardGroup implements VisualizationTypeStrategy {
  public getEditableComponent(): EditableComponent {
    return {
      visualizationType: VisualizationType.STATUS_CARD_GROUP,
      name: 'editable:StatusCardGroup',
      displayName: 'Status Card Group',
      displayIcon: 'Widget.StatusLight',
      editorTemplate: StatusCardGroupEditor,
      propertiesPanel: StatusCardGroupPropertiesPanel,
    };
  }
}
